import { render, staticRenderFns } from "./ProductGroupTurnover.vue?vue&type=template&id=8df31214&"
import script from "./ProductGroupTurnover.vue?vue&type=script&lang=js&"
export * from "./ProductGroupTurnover.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupTurnover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VCard,VListItem,VListItemContent,VListItemTitle})
